import { Button } from '@chakra-ui/react'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'
import { useEffect, useState } from 'react'

import {
  FormSection,
  FormSectionBody,
  FormSectionDescription,
  FormSectionHeader,
  FormSectionTitle,
} from '../../components/FormSection'
import { MainContent } from '../../components/MainContent'
import { Save } from '../../icons'
import { AdditionalInsureeSmeInfo } from '../AdditionalInsureeSmeInfo'
import { FormButtons } from '../FormButtons'
import { InsuredFields } from './InsuredFields'

interface Step4FormProps {
  onSubmit: (values: Step4FormValues) => void
}

interface InsuranceField {
  value: string
  label: string
}

export interface Step4FormValues {
  insureeType: string
  businessId: string
  namePrefix: string
  firstName: string
  lastName: string
  namePostfix: string
  street: string
  houseNumber: string
  mobilePhonePrefix: string
  mobilePhoneNumber: string
  landlinePrefix: string
  landlineNumber: string
  email: string
  acceptECommunication: boolean
  insuredFields?: InsuranceField[] | null
}

const MOCK_insuredFields: InsuranceField[] = [
  {
    value: 'maloobchod-mimo-prodejny-stanky-a-trhy',
    label: 'Maloobchod mimo prodejny, stánky a trhy',
  },
  {
    value: 'maloobchod-prostrednictvim-internetu',
    label: 'Maloobchod prostřednictvím internetu',
  },
  {
    label: 'Maloobchod prostřednictvím internetu nebo zásilkové služby',
    value: 'maloobchod-prostrednictvim-internetu-nebo-zasilkove-sluzby',
  },
  {
    value:
      'maloobchod-prostrednictvim-zasilkove-sluzby-jiny-nez-prostrednictvim-internetu',
    label:
      'Maloobchod prostřednictvím zásilkové služby (jiný než prostřednictvím internetu)',
  },
]

export const Step4Form = ({ onSubmit }: Step4FormProps) => {
  const [insuredFields, setInsuredFields] = useState<InsuranceField[]>([])
  const [insuredFieldsLoading, setInsuredFieldsLoading] =
    useState<boolean>(false)

  const methods = useForm<Step4FormValues>({
    defaultValues: {
      insureeType: '1',
      businessId: '7505250000',
      firstName: 'Jan',
      lastName: 'Novák',
      street: 'Hlavní třída',
      houseNumber: '331',
      mobilePhonePrefix: '+420',
      landlinePrefix: '+420',
      email: 'jan.novak@email.cz',
      acceptECommunication: true,
      insuredFields: [],
    },
  })
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods

  const onSubmitForm = (values: Step4FormValues) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        onSubmit(values)
        resolve(true)
      }, 500)
    })
  }

  // This simulates loading of insured fields from your backend
  useEffect(() => {
    setInsuredFieldsLoading(true)

    setTimeout(() => {
      setInsuredFields(MOCK_insuredFields)
      setInsuredFieldsLoading(false)
    }, 1000)
  }, [])

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <MainContent>
          <FormSection>
            <FormSectionHeader>
              <FormSectionTitle>
                Doplňující informace o pojistníkovi
              </FormSectionTitle>

              <FormSectionDescription>
                Doplňte informace o pojistníkovi a dalších osobách pro sjednání
                pojištění.
              </FormSectionDescription>
            </FormSectionHeader>

            <FormSectionBody>
              <AdditionalInsureeSmeInfo />
            </FormSectionBody>
          </FormSection>

          <FormSection>
            <FormSectionHeader>
              <FormSectionTitle>Pojištěné obory</FormSectionTitle>

              <FormSectionDescription>
                Vyberte všechny obory klienta k pojištění.
              </FormSectionDescription>
            </FormSectionHeader>

            <FormSectionBody>
              <InsuredFields
                options={insuredFields}
                isLoading={insuredFieldsLoading}
              />
            </FormSectionBody>
          </FormSection>

          <FormButtons
            rightButtons={
              <>
                <Button variant="outline" disabled={isSubmitting} type="button">
                  Uložit
                </Button>
                <Button
                  colorScheme="primary"
                  isLoading={isSubmitting}
                  isDisabled={isSubmitting}
                  loadingText="Ukládám..."
                  type="submit"
                >
                  <Save />
                  Uložit a pokračovat na shrnutí
                </Button>
              </>
            }
          />
        </MainContent>
      </form>
    </FormProvider>
  )
}
